import { defineStore } from "pinia";
import { store } from "@/store";
import { userType } from "./types";
import { routerArrays } from "@/layout/types";
import { router, resetRouter } from "@/router";
import { storageSession } from "@pureadmin/utils";
import { login } from "@/api/user";
// import { UserResult } from "@/api/user";
import { useMultiTagsStoreHook } from "@/store/modules/multiTags";
import { type DataInfo, setToken, removeToken, sessionKey } from "@/utils/auth";
import type { RouteConfigsTable } from "/#/index";
import { UserResult } from "/#/JHT";

export const useUserStore = defineStore({
  id: "pure-user",
  state: (): userType => ({
    // 用户名
    telNo: storageSession.getItem<DataInfo>(sessionKey)?.telNo,
    // 用户类型，"ADMIN" | "OPERATOR";
    userType: storageSession.getItem<DataInfo>(sessionKey)?.userType,
    // 路由权限
    menuPermisionModelList:
      storageSession.getItem<DataInfo>(sessionKey)?.menuPermisionModelList,
    // 判断登录页面显示哪个组件（0：登录（默认）、1：手机登录、2：二维码登录、3：注册、4：忘记密码）
    currentPage: 0,
    merchantNo: storageSession.getItem<DataInfo>(sessionKey)?.merchantNo,
    uid: storageSession.getItem<DataInfo>(sessionKey)?.uid,
    model: storageSession.getItem<DataInfo>(sessionKey)?.model,
    channelCode: storageSession.getItem<DataInfo>(sessionKey)?.channelCode
  }),
  actions: {
    /** 存储手机号 */
    SET_TELNO(telNo: string) {
      this.telNo = telNo;
    },
    /** 存储uid */
    SET_UID(id: string) {
      this.uid = id;
    },
    /** 存储model */
    SET_Model(model: object) {
      this.model = model;
    },
    /** 存储角色 */
    SET_USERTYPE(userType: string) {
      this.userType = userType;
    },
    /** 存储角色 */
    SET_ROUTERLIST(userType: string) {
      this.userType = userType;
    },
    SET_MERCHANTNO(merchantNo: string) {
      this.merchantNo = merchantNo;
    },
    SET_ChannelCode(channelCode: string) {
      this.channelCode = channelCode;
    },
    /** 存储登录页面显示哪个组件 */
    SET_MENUPERMISION(value: Array<RouteConfigsTable>) {
      this.menuPermisionModelList = value;
    },
    /** 登入 */
    async loginByUsername(data) {
      return new Promise<UserResult>((resolve, reject) => {
        login(data)
          .then(res => {
            if (res) {
              console.log("登录res", res);
              setToken(res);
              resolve(res);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /** 前端登出（不调用接口） */
    logOut(expire = false) {
      this.telNo = "";
      this.menuPermisionModelList = [];
      removeToken();
      useMultiTagsStoreHook().handleTags("equal", [...routerArrays]);
      resetRouter();
      const query = expire
        ? {
            redirect: encodeURIComponent(router.currentRoute.value.fullPath)
          }
        : {}; // 登录态过期后跳入浏览的当前页面
      router
        .replace({
          path: "/login",
          query
        })
        .then(() => {
          location.reload();
        });
    }
    /** 刷新`token` */
    // async handRefreshToken(data) {
    //   return new Promise<RefreshTokenResult>((resolve, reject) => {
    //     refreshTokenApi(data)
    //       .then(data => {
    //         if (data) {
    //           setToken(data.data);
    //           resolve(data);
    //         }
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   });
    // }
  }
});

export function useUserStoreHook() {
  return useUserStore(store);
}
